import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  selectPackagesInBasket,
  selectPackagesInShop,
  selectProductsInBasket,
  selectProductsList,
} from '../../actions/selector';
import { ShoppingCartState } from '../../actions/standalone';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Pipe({
    name: 'productInPackagePhoto',
    standalone: false
})
export class ProductInPackagePhotoPipe implements PipeTransform {
  productsList$ = this.store.pipe(select(selectProductsList));
  selectedProductsList$ = this.store.pipe(select(selectProductsInBasket));
  packagesInBasket$ = this.store.pipe(select(selectPackagesInBasket));
  packagesInShop$ = this.store.pipe(select(selectPackagesInShop));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(productInPackageId: string, packageId: string): Observable<string> {
    return this.packagesInShop$.pipe(
      map((packagesInShop) => ({
        productInPackage: packagesInShop.package
          .find((packageInBasket) => packageInBasket.packageId === packageId)
          .productConfig.find(
            (value) => value.productInPackageId === productInPackageId
          ),
      })),
      switchMap(({ productInPackage }) =>
        this.productsList$.pipe(
          map((productsList) => ({
            productInPackage,
            product: productsList.find(
              (value1) => value1.productId === productInPackage.productId
            ),
          }))
        )
      ),
      map(({ productInPackage, product }) => {
        if (productInPackage?.icon) {
          return productInPackage.icon;
        } else {
          return product?.composedImages.find((value) => value.config === null)
            .fileName;
        }
      })
    );
  }
}
